//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'alliance_bindphone',
  data() {
    return {
      title: '绑定手机',
      isDisabled: true,//验证码禁用
      bindDisabled: true,//提交禁用
      time: 60,//倒计时时间
      code: "",//验证码
      mobile: "",//电话
      judge:this.$router.judge,
      url: window.location.href,//当前地址

    }
  },
  computed: {
    isdisabledFn() {
      var self = this;
      if (this.mobile != "" && this.mobile.match(/^[0-9]{11}$/) && this.code != "" && this.code.match(/^[0-9]{6}$/)) {
        return self.bindDisabled = false;
      } else {
        return self.bindDisabled = true;
      }
    }
  
  },
  created(){
     if(sessionStorage.getItem('token') == null){
      this.get_token(this.url);
     }
  },
  methods: {
      //获取token
    get_token(url) {
        this.$EpetJs.Common.approve(url,function(){})  //生成token
    },
    //获取验证码
    send() {
      let self = this;
      if (self.mobile == "") {
        self.$vux.toast.text("请填写你的手机号码！");
        return;
      }
      if (!self.mobile.match(/^[0-9]{11}$/)) {
        self.$vux.toast.text("请输入正确的手机号!");
        return;
      }
      self.isDisabled = false;
      this.$EpetJs.Common.post("public/sms", {
        mobile: this.mobile
      }).then(({ data }) => {
        let interval = window.setInterval(function () {
          if (self.time-- <= 0) {
            self.time = 60;
            self.isDisabled = true;
            window.clearInterval(interval);
          }
        }, 1000);
      });
    },
  
    //绑定
    bindPhone() {
      let self = this;
      this.$EpetJs.Common.post("public/user/bind/mobile", {
        mobile: this.mobile,
        code: this.code
      }).then(({ data }) => {
        if (data.status_code == 200) {
           if(self.judge==1){
               self.$router.push({ name: 'alliance_exchange' });
           }else{
           self.$router.push({ name: 'alliance_personal' });
           }
        
        }
        else {
          self.$vux.toast.text(data.message);
        }
      });
    },


  }
}
